import { Stack, Typography } from "@mui/material";
import { TierCircle } from "components/TierCircle";
import Routes from "constants/routes";
import { ReactNode } from "react";
import { ClickableTypography } from "../ClickableTypography";

type Props = {
  currentTierColor?: string;
  currentTier?: string;
  clubNumber?: string | number;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  children?: ReactNode | ReactNode[];
  showTierIcon?: boolean;
  iconPlacement?: "left" | "right";
};

export const PlayerNameCell = (props: Props) => {
  const {
    currentTier,
    currentTierColor,
    clubNumber,
    fullName,
    firstName,
    lastName,
    children,
    showTierIcon = true,
    iconPlacement,
  } = props;
  let displayName = fullName;
  if (!displayName) {
    displayName = `${firstName} ${lastName}`;
  }
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {iconPlacement === "left" ? children : null}
      {showTierIcon && currentTierColor && <TierCircle color={currentTierColor} name={currentTier} />}
      {clubNumber && <ClickableTypography to={Routes.overviewPathFor(clubNumber)}>{displayName}</ClickableTypography>}
      {!clubNumber && <Typography>{displayName}</Typography>}
      {iconPlacement === "right" || iconPlacement === undefined ? children : null}
    </Stack>
  );
};
